import AAvatar from './index.vue';

AAvatar.install = app => {
  app.component(AAvatar.name, AAvatar);
};

export default AAvatar;
